import { Injectable } from '@angular/core'
import {
  BiddingItemEntity,
  DonationItemEntity,
  ItemTypeEnum,
  PurchaseItemEntity,
  RaffleItemEntity,
} from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import { AbstractControl, FormControl } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { GbCurrencyPipe } from 'libs/gb-front/shared/pipes/src/lib/gb-currency-pipe/gb-currency.pipe'
import { GenericErrorMap, ItemErrorMessageMap } from './gb-validation-messages.models'
import { EventTicketPackageEntity } from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.models'

@Injectable({
  providedIn: 'root',
})
export class GbValidationMessagesService {
  private genericErrorMessageMap: GenericErrorMap = {
    min: (control: FormControl) =>
      this.translateService.instant('VALIDATION.MIN_ERROR_MESSAGE_GENERIC', {
        min: control.errors?.['min'].min,
      }),
    minlength: (control: FormControl) =>
      this.translateService.instant('VALIDATION.MIN_LENGTH_ERROR_MESSAGE_GENERIC', {
        min: control.errors?.['minlength'].requiredLength,
      }),
    max: (control: FormControl) =>
      this.translateService.instant('VALIDATION.MAX_ERROR_MESSAGE_GENERIC', {
        max: control.errors?.['max'].max,
      }),
    maxlength: (control: FormControl) =>
      this.translateService.instant('VALIDATION.MAX_LENGTH_ERROR_MESSAGE_GENERIC', {
        max: control.errors?.['maxlength'].requiredLength,
      }),
    wholeNumber: (control: FormControl) => 'VALIDATION.WHOLE_NUMBER_ERROR_MESSAGE',
    noMatch: (control: FormControl) => this.translateService.instant('CONFIRM_PASSWORD_ERROR_MESSAGE'),
  }

  private itemErrorMessageMap: ItemErrorMessageMap = {
    min: {
      [ItemTypeEnum.Donation]: (control: FormControl, item: DonationItemEntity) =>
        this.translateService.instant('ITEM.DONATE.AMOUNT_ERROR', {
          amount: this.getFormattedAmount(control.errors?.['min'].min),
        }),
      [ItemTypeEnum.Bidding]: (control: FormControl, item: BiddingItemEntity) =>
        item.hide_price
          ? this.translateService.instant('ITEM.BID.TOO_LOW_ERROR')
          : this.translateService.instant('ITEM.BID.AMOUNT_ERROR', {
              amount: this.getFormattedAmount(control.errors?.['min'].min),
            }),
    },
  }

  constructor(private translateService: TranslateService, private currency: GbCurrencyPipe) {}

  getValidatorErrorMessage(
    control: FormControl | AbstractControl,
    item:
      | DonationItemEntity
      | BiddingItemEntity
      | PurchaseItemEntity
      | RaffleItemEntity
      | EventTicketPackageEntity
      | null = null,
  ): string {
    if (!control.errors) return ''

    let error = ''
    const keys = Object.keys(control.errors)

    for (const key of keys) {
      const itemError = item && 'item_type' in item ? this.itemErrorMessageMap[key]?.[item.item_type] : null
      const genericError = this.genericErrorMessageMap[key]

      if (itemError) {
        error = itemError(control, item)
        break
      } else if (genericError) {
        error = genericError(control)
        break
      }
    }
    return error
  }

  private getFormattedAmount = (amount: number) => this.currency.transform(amount)
}
